import AxiosWrapper from "./AxiosWrapper"

export default class Waze extends AxiosWrapper {
  protected static getApiUrl(){
    return process.env.REACT_APP_WAZE_URL
  }
}
